import React from 'react'
import ProfilePic from '../../assests/john-doe-image.png'
import {AiFillStar} from 'react-icons/ai'

const Testimonials = () => {
  return (
    <div className='work-section-wrapper'>
        <div className='work-section-top'>
            <p className='primary-subheading'>Testimonials</p>
            <h1 className='primary-heading'>What They are Saying</h1>
            <p className='primary-text'>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse adipisci inventore ut quis temporibus animi reiciendis ullam pariatur.
            </p>
        </div>
        <div className='testimonial-section-bottom'>
            <img src={ProfilePic}/>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Et ea illum dolorum aperiam fugit molestias id commodi voluptate sit eveniet!
            </p>
            <div className='testimonials-stars-container'>
                <AiFillStar/>
                <AiFillStar/>
                <AiFillStar/>
                <AiFillStar/>
                <AiFillStar/>
            </div>
            <h2>John Doe</h2>
        </div>
      
    </div>
  )
}

export default Testimonials
